/** constantes de travail pour les engines */
export class WizConstants {

    public static readonly KEY_SEPARATOR: string = '|'; // séparateur pour les éléments de clé (pkd, baselines...)
    public static readonly DOUBLEKEY_SEPARATOR: string = '||'; // séparateur pour les éléments de clé mesures de type liste
    public static readonly CONTEXT_SEPARATOR: string = '#'; // séparateur des champs de contexte (pour former la clé)
    public static readonly CODE_LEVEL_SEPARATOR: string = '_'; // séparateur pour les éléments de hiérarchie (chrono / FDV)
    public static readonly WIDGET_KEY_SEPARATOR: string = '/'; // séparateur de clé d'entrée de contexte de widget
    public static readonly FD_PARTS_SEPARATOR: string = '@'; // séparateur des sous-propriétés sur FDV.fdv.value
    public static readonly KEY_PAIR_SEPARATOR: string = ':'; // séparateur d'éléments clé-valeur (json like)
    public static readonly STYLE_ELEMENT_SEPARATOR: string = ';'; // séparateur de paires (json like)
    public static readonly NICE_KEY_SEPARATOR: string = '-'; // séparateur de paires (pour faire joli)
    public static readonly FILTER_ELEMENT_SEPARATOR: string = ','; // séparateur d'éléments de filtre
    public static readonly DOT_SEPARATOR: string = '.'; // séparateur .

    public static readonly BASE_SCENARIO = 'MAIN'; // code du scénario de base
    public static readonly CHRONO: string = 'CHRONO'; // constante de code Chronocode
    public static readonly FAKE: string = 'FAKE'; // mot-clé pour signaler un fake
    public static readonly RAW: string = 'RAW'; // rendu en mode "brut" des valeurs de mesures (listes)
    public static readonly REVERT_MESURE_COLUMN: string = '@@REVERT'; // 1ère colonne, porte les mesures en mode pivot.revert
    public static readonly TRIGGER_ALWAYS = 'ALWAYS'; // recalcul systématique pour cette valeur de FDV
    public static readonly ALLKEYME: string = 'ALLKEYME'; // constante allkeyme, mot clé réservé, utilisé pour les connexions

    public static readonly SCEN_KEY_CODE = 'SCEN@'; // code du faux FD pour les scenars
    public static readonly SCEN_FAKE_KEY_CODE = '@@FAKE'; // code du fei FAKE

    public static readonly SERIE_CODE = '@@SER'; // marquer une entrée de collection comme étant une série

    public static readonly wildcardDomain: string = '*'; // le domaine de base des codifs bas niveau, utilisé aussi comme base pour bu
    public static readonly wildcardDomainForConnect: string = '__SETTINGS'; // le domaine de base des codifs bas niveau, utilisé aussi comme base pour bu
    public static readonly wildcardAsKey: string = 'MAIN'; // le wildcard dans les constructions de clés
    
    public static readonly defaultVision: string = '*'; // la vision par défaut
    public static readonly err: string = 'err'; // élément en erreur

    public static readonly defaultLocaleCode: string = 'en'; // la langue par défaut
    public static readonly defaultChronoCode = 'EON'; // unité temporelle par défaut
  
    /** les modes FIST */
    public static readonly MEASURE_MODE_FROM: string = 'F';
    public static readonly MEASURE_MODE_INTERACT: string = 'I';
    public static readonly MEASURE_MODE_SUBMIT: string = 'S';
    public static readonly MEASURE_MODE_TO: string = 'T';
    public static readonly MEASURE_MODE_CONSTANT: string = 'C'; // une constante (à la vision)
    public static readonly MEASURE_MODE_WEIGHT_GRID: string = 'W'; // le code d'une grille de poids
    /** tous les modes autorisés */
    public static readonly MEASURE_MODE_ALL: string = 'FISTWC';

   /** mode de navigation */
   public static NAVIGATION_WEB: string = 'web';
   public static NAVIGATION_TABLE: string = 'table';

  /* #############################################################
         champs normalisés sur les FDVs
     ############################################################# */
    
    // champ label 
    public static readonly FIELD_LABEL: string = 'label';
    // champ code 
    public static readonly FIELD_CODE: string = 'code';
    // champ code parent
    public static readonly FIELD_PARENT_CODE: string = 'parentCode';
    // champ shortCode 
    public static readonly FIELD_SHORT_CODE: string = 'shortCode';
    // champ description 
    public static readonly FIELD_DESCRIPTION: string = 'description';
    // champ contrôle d'édition sur les mesures 
    public static readonly FIELD_EDIT_RESTRICT: string = 'editRestrictMessage';
    // champ contrôle de cohérence sur les mesures 
    public static readonly FIELD_VALUE_CONTROL: string = 'valueControlMessage';
    // champ startDate par défaut sur les aggrégats de chronocodes
    public static readonly FIELD_STARTDATE: string = 'startDate';
    // champ endDate 
    public static readonly FIELD_ENDDATE: string = 'endDate';
    // champ value 
    public static readonly FIELD_VALOR: string = 'valor';
    // champ ordre 
    public static readonly FIELD_ORDER: string = 'order';
    // champ createBy 
    public static readonly FIELD_CREATE_BY: string = 'createBy';
    // champ updateBy 
    public static readonly FIELD_UPDATE_BY: string = 'updateBy';

  /* #############################################################
         calculs sur FakeFEI (control, restrict, styles, forms)
     ############################################################# */

    public static readonly CHECK_MODE_CONTROL: string = 'valueControl'; // contrôle de cohérence sur saisie
    public static readonly CHECK_MODE_INTEGRITY: string = 'formulaI'; // contrôle de cohérence global (widget.i)
    public static readonly CHECK_MODE_RESTRICT: string = 'editRestrict'; // contrôle de cohérence pour autoriser l'édition

    public static readonly FAKE_STYLE: string = '@@FS'; // expression de style
    public static readonly FAKE_EDIT_RESTRICT: string = '@@FER'; // contrôle avant édition
    public static readonly FAKE_TRIGGER: string = '@@TRIG'; // déclenchement par trigger
    public static readonly FAKE_INTEGRITY: string = '@@FI'; // contrôle d'intégrité avant update / create / delete

    public static readonly FAKE_DEFAULT_VALUE: string = '@@FVAL'; // Ajouter les valeurs par défaut sur création dans Form
    public static readonly FAKE_LIST_RESTRICT: string = '@@FLIST'; // Filtrer les éléments disponibles dans une liste (filterKey)
    
    public static readonly FAKE_FREE: string = '@@FFREE'; // calcul libre (fonctions series)

    public static readonly INJECT_RESPONSE_KEY: string = '@@INJECT@@'; // pour identification sur retour d'injection
    public static readonly INJECT_USER_KEY: string = '@@USER@@'; // injection d'un param USER
    public static readonly INJECT_GLOBAL_KEY: string = '@@GLOBAL@@'; // injection d'un param de filtre global

    public static readonly CROSSED_FD: string = 'FREEDATA';
    public static readonly CROSSED_SELF: string = 'SELF';
    public static readonly CROSSED_VISION: string = 'VISION';
   
}


